import { useDispatch, useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { storeStaffList } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { UserRoles } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { useApiQuery } from './useApiQuery';

const useStaffList = ({ useruuid }) => {
  const dispatch = useDispatch();

  const trans = useSelector(translator);
  const userApi = useSelector((state) => state.apis.userApi);

  return useApiQuery(
    ['staffList', useruuid],
    () =>
      new Promise((resolve, reject) => {
        userApi.getContactsByRole(
          useruuid,
          UserRoles.staff,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              dispatch(storeStaffList({ useruuid, staffList: data?.contacts ?? [] }));
              resolve(data?.contacts ?? []);
            },
            errorCallback: () => {
              reject([]);
            },
          })
        );
      }),
    { enabled: !!useruuid }
  );
};

export default useStaffList;
